module.exports = __webpack_public_path__ + "static/img/slmServer1.9fe26f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slmServer1.png
// module id = ssrH
// module chunks = 2